import Vue from 'vue'

export default {
    UPDATE_CONTENTS (state, value) {
      Vue.set(state, 'conts', value);
    },
    SET_CONTENTS (state, value) {
      this.commit('UPDATE_CONTENTS', value);
    },
    SET_SELECTED_CONTENT (state,  value ) {
      Vue.set(state, 'selectedContent', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/contents/mutations.js